import { FC, useMemo, useState } from 'react';
import { Alert, Box, Button, Chip, Stack, TextField, Typography } from '@mui/material';

const MAX_WORDS = 50;

function parseWords(raw: string): string[] {
    return Array.from(
        new Set(
            raw
                .split(/[\n,]+/)
                .map((t) => t.trim())
                .filter((t) => t.length > 0),
        ),
    );
}

interface Props {
    onBack: () => void;
    onSubmit: (words: string[]) => void;
}

export const StepWordListInput: FC<Props> = ({ onBack, onSubmit }) => {
    const [raw, setRaw] = useState('');
    const words = useMemo(() => parseWords(raw), [raw]);
    const over = words.length > MAX_WORDS;

    return (
        <Stack spacing={2} sx={{ pt: 1 }}>
            <Typography variant="body2" color="text.secondary">
                줄바꿈 또는 콤마로 구분된 단어 목록을 입력하세요. 최대 {MAX_WORDS}개까지 가능합니다.
            </Typography>
            <TextField
                multiline
                rows={8}
                fullWidth
                placeholder={'apple\nbanana\ncherry'}
                value={raw}
                onChange={(e) => setRaw(e.target.value)}
            />
            <Box>
                <Typography variant="caption" color={over ? 'error' : 'text.secondary'}>
                    {words.length} / {MAX_WORDS}
                </Typography>
            </Box>
            {words.length > 0 && (
                <Stack direction="row" flexWrap="wrap" gap={0.5}>
                    {words.slice(0, 50).map((w, idx) => (
                        <Chip key={`${w}-${idx}`} label={w} size="small" />
                    ))}
                </Stack>
            )}
            {over && <Alert severity="warning">단어가 너무 많습니다. {MAX_WORDS}개 이하로 줄여주세요.</Alert>}
            <Box display="flex" justifyContent="space-between" pt={1}>
                <Button onClick={onBack}>뒤로</Button>
                <Button
                    variant="contained"
                    disabled={words.length === 0 || over}
                    onClick={() => onSubmit(words)}
                >
                    다음
                </Button>
            </Box>
        </Stack>
    );
};
